export default __webpack_public_path__ + "static/media/ja.c01a47da.svg";